import { ErrorCode, ResponceDataType } from "../../../../ErrorCode";
import iconv from 'iconv-lite';
import { parse } from 'csv-parse/lib/sync';
import i18next from 'i18next';

/**
 *機器管理台帳読込用Type
 */
export type NameDevSetModel = {
  DevNo: string;
  DevName: string;

  indexNo: number;
};

/**
 * 機器管理台帳CSV読込
 * @param targetList
 * @returns
 */
export const PutNameDevSetCsvData = (targetList: NameDevSetModel[]): Promise<ResponceDataType> => {
  return new Promise((resolve, reject) => {
    fetch("api/NameDevSet/readcsv", {
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(targetList),
    })
      .then((res) => {
        if (!res.ok) {
          let message = `データが見つかりませんでした status:${res.status}`;
          reject(message);
        }
        else {
          return res.json();
        }
      })
      .then((result: ResponceDataType) => {
        if (result.ErrorCode === ErrorCode.ERR_CODE_NONE) {
          resolve(result);
        }
        else {
          reject(result);
        }
      })
      .catch(error => {
        console.error(error);
        reject(error)
      });
  });
}

/**
 * 入力チェック
 */
export const CheckInputData = (targetList: NameDevSetModel[], translation: any): string[] => {
  let errorMsgs: string[] = [];

  targetList.forEach((r, index) => {
    if (!r.DevNo) {
      errorMsgs.push(`No:${index + 1} ` + i18next.t('ReadDevCsvDialog.機器番号必須', '機器番号必須です'));
    }
    if (r.DevNo.length > 10) {
      errorMsgs.push(`No:${index + 1} ` + i18next.t('ReadDevCsvDialog.機器番号最大文字数', '機器番号最大10文字です'));
    }
    if (r.DevName.length > 32) {
      errorMsgs.push(`No:${index + 1} ` + i18next.t('ReadDevCsvDialog.機器番号文字数', '機器番号は32文字です'));
    }
  });

  return errorMsgs;
}


/**
 *　csvファイル選択パーサー
 * @param fileObject　CSVファイルobject
 * @returns　成功した場合、読み込んだファイルの配列を返す
 */
export const ReadAsCsvReader = (fileObject: File): Promise<string | ArrayBuffer | null> => {

  const reader = new FileReader();

  return new Promise((resolve, reject) => {
    reader.onloadstart = ev => {
      console.debug(`onloadstart: total=${ev.loaded}/${ev.loaded}`);
    };

    reader.onloadend = ev => {
      console.debug(`onloadend: total=${ev.loaded}/${ev.loaded}`);
    };

    reader.onprogress = ev => {
      console.debug(`onprogress: total=${ev.loaded}/${ev.loaded}`);
    };

    reader.onerror = () => {
      reader.abort();
      reject('Unknown error occurred during reading the file');
    };

    reader.onload = () => {
      console.debug('onload');
      resolve(reader.result);
    };

    reader.readAsArrayBuffer(fileObject);
  });
};


/**
 *　ArrayBufferを元にNameDevSetModelのリストを返す
 * @param datas　
 * @returns
 */
export const CreateNameDevSetList = (datas: ArrayBuffer): Promise<NameDevSetModel[]> => {

  return new Promise((resolve, reject) => {
    // CSVファイルの文字コードを Shift_JIS に変換する。
    const csvString = iconv.decode(Buffer.from(datas), 'Shift_JIS');
    // CSVファイルを JavaScriptのオブジェクト に変換する。
    const records = parse(csvString, {
      columns: true,
      trim: true,
      skip_empty_lines: true,
      relax_column_count: true,
    });

    if (records.length == 0) {
      return reject('data format error');
    }

    let list: NameDevSetModel[] = [];
    for (const record of records) {
      const newRow: NameDevSetModel = {
        indexNo: 0,
        DevName: record['機器名'],
        DevNo: record['機器番号'],
      };
      if (newRow.DevNo != null && newRow.DevNo !== '') {
        list.push(newRow);
      }
    }

    if (list.length === 0) {
      return reject('data format error');
    }

    // 重複を削除したリストを作成
    const list2 = list.filter((x, i, self) => self.findIndex((y) => y.DevNo === x.DevNo) === i);
    //連番付与
    list2.forEach((r, index) => (r.indexNo = index + 1));
    console.debug(['list', list2]);
    return resolve(list2);

  });
};
